/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
==========================================================================================*/


export default {
  UPDATE_ARTICLE(state, payload) {
    if (payload != null)
      state.articles = payload;
  },
  UPDATE_CLIENT(state, payload) {
    if (payload.value != null)
      state.clients = payload;
    else {
      state.clients = {
        value: []
      }
    }
  },
  UPDATE_FILTERS(state, payload) {
    if (payload != null) {
      state.articleCategories = payload.categories;
      state.articleFournisseurs = payload.fournisseur;
    }
  },
  UPDATE_ANALTCS_DATA(state, payload) {
    if (payload != null && payload.value != null) {
      state.analytcsdata.listData = payload.value
    }
    else state.analytcsdata.listData = []
  },
  UPDATE_CURRENT_CLIENT_INFO(state, payload) {
     
    state.analytcsdata.userInfo = payload.value[0]
  },
  UPDATE_PERIODE(state, payload) {
    state.analytcsdata.periode = payload
  },
  UPDATE_PERIODE_YEAR(state, payload) {
    state.analytcsdata.selectedyear = payload
  }
}
